import { Stack } from '@mui/material'
import { Chip, CHIP_SIZE, CHIP_TYPE, COLORS } from '@repo/design-system/index'
import { QIcon_bar_graph, QIcon_chat, QIcon_mic } from '@repo/icons/index'
import { n_ai_speaking, n_ai_tutor } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { useCreateRolePlayStore } from '../../../../store/useCreateRolePlayStore'
import { usePersonaStore } from '../../../../store/usePersonaStore'
import InfoSection from '../../../new-portal/ai-tutor/InfoSection'
import { purposeItems } from './content'
import { getPurposeName } from './getNames'
import PersonaCard from './with_whom/PersonaCard'

const Summary = () => {
  const { purposeIds, personaId } = useCreateRolePlayStore()
  const { personas } = usePersonaStore()
  const persona = personas.find((x) => x.id === personaId)
  const { locale, t } = useTranslation()

  return (
    <div style={{ position: 'relative', height: '100%', display: 'flex' }} className="flex-col">
      <div className="p-[20px]">
        <span className="Headline3-22Bd">{t(n_ai_tutor.custom_roleplay.step3_title_1)}</span>
      </div>
      <div className="flex flex-col items-start">
        <div className="flex flex-col p-[24px]" style={{}}>
          <div className="bg-purple-50 px-[6px] py-[2px]" style={{ borderRadius: 4 }}>
            <span className="text-purple-500 Caption-12Bd">{t(n_ai_tutor.roleplay_intro.label3)}</span>
          </div>
        </div>
        <PersonaCard persona={persona} showDeleteBtn={false} />
      </div>

      <div className="flex flex-col items-start">
        <div className=" p-[24px]">
          <div className="bg-purple-50 px-[6px] py-[2px]" style={{ borderRadius: 4 }}>
            <span className="text-purple-500 Caption-12Bd">{t(n_ai_tutor.roleplay_intro.label4)}</span>
          </div>
        </div>

        <div className="px-[20px]" style={{ width: '100%' }}>
          <div
            className="flex flex-col p-[16px] border-gray-200"
            style={{ borderWidth: 1, borderRadius: 12, width: '100%' }}
          >
            <div className="">
              {purposeItems
                .filter((item) => purposeIds.includes(item.id))
                .map((item) => (
                  <Chip type={CHIP_TYPE.ACTIONABLE} size={CHIP_SIZE.SM} key={item.id} customBgColor={COLORS.GRAY100}>
                    <Chip.Label customTxtColor={COLORS.GRAY600}>{getPurposeName(item.id, locale)}</Chip.Label>
                  </Chip>
                ))}
            </div>
          </div>
        </div>
      </div>
      {/* {showCustomPurpose && <span>custom: {customPurpose}</span>}
      background: {background} */}

      <div className="p-[20px]">
        <div className="bg-gray-50 rounded-lg p-[24px] flex flex-col gap-[20px] items-start justify-start self-stretch shrink-0 mt-[40px] mb-[40px]">
          <InfoSection
            icon={<QIcon_mic fill={COLORS.GRAY500} width={24} height={24} />}
            title={t(n_ai_tutor.roleplay_intro.info_title1)}
          >
            * {t(n_ai_speaking.aI_intro.msg2)}
          </InfoSection>
          <InfoSection
            icon={<QIcon_bar_graph fill={COLORS.GRAY500} width={24} height={24} />}
            title={t(n_ai_tutor.roleplay_intro.info_title2)}
          >
            <div>* {t(n_ai_tutor.roleplay_intro.info_detail)}</div>
            <div>* {t(n_ai_tutor.roleplay_intro.info_word_detail)}</div>
          </InfoSection>
          <InfoSection
            icon={<QIcon_chat fill={COLORS.GRAY500} width={24} height={24} />}
            title={t(n_ai_tutor.roleplay_intro.info_title3)}
          >
            <div className="flex flex-col ">
              <div>* {t(n_ai_speaking.aI_intro.msg4)}</div>
              <div>* {t(n_ai_speaking.aI_intro.msg5)}</div>
            </div>
          </InfoSection>
        </div>

        <Stack style={{ height: 100 }} sx={{ pt: 8 }}></Stack>
      </div>
    </div>
  )
}
export default Summary
